var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShippingPackages116X116(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "116px",
    height: "116px",
    viewBox: "0 0 116 116",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/shippingpackages/116x116") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/shippingpackages/116x116",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "white-circle",
    fill: "#FFFFFF",
    cx: 58.5,
    cy: 58.5,
    r: 52.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "delivery-truck-2",
    transform: "translate(11, 5)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.0838, 18.7486)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.1895, 51.611)",
    fill: "#303026",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6.4414228 L9.47455585,6.4414228 C10.2356219,3.51613903 12.3430922,1.13303692 15.0887875,0 L0,0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0497202,0 L22.3113295,0 C25.0572356,1.13303692 27.1647059,3.51613903 27.9255612,6.4414228 L36.4519451,6.4414228 C37.6156682,6.4414228 38.5589939,5.49398046 38.5589939,4.32517903 L38.5589939,0.211624377 L38.0497202,0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.7451102,41.5841902 L93.588578,41.5841902 L93.748503,41.3725658 L93.748503,38.1342896 C93.748503,37.6155982 93.6709636,37.1028323 93.5234702,36.6110173 L93.2276405,36.3993929 L65.7388705,36.3993929 C65.2740556,36.3993929 64.896051,36.0197388 64.896051,35.5528954 L64.896051,23.4903059 C64.896051,23.0234625 65.2740556,22.6438084 65.7388705,22.6438084 L84.7682608,22.6438084 L84.8845699,22.432184 L83.2004058,19.7379941 C82.8150265,19.1213206 82.1409816,18.7469571 81.4159461,18.7469571 L59.0936599,18.7469571 L59.0936599,51.8225775 L69.8006286,51.8225775 C71.0406269,51.2289712 72.4268543,50.8954511 73.8895676,50.8954511 C75.3522809,50.8954511 76.7385083,51.2287595 77.9785066,51.8225775 L93.748503,51.8225775 L93.748503,48.779419 L93.6353545,48.5677946 L89.7451102,48.5677946 C89.2802952,48.5677946 88.9022906,48.1881405 88.9022906,47.7212971 L88.9022906,42.4306877 C88.9022906,41.9638443 89.2802952,41.5841902 89.7451102,41.5841902 Z",
    id: "Path",
    fill: "#F41381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.10704885,0 C0.943325769,0 0,0.947442338 0,2.11624377 L0,34.0715248 L29.951278,34.0715248 C30.4160929,34.0715248 30.7940975,34.4511789 30.7940975,34.9180223 L30.7940975,43.8528035 L54.3466895,43.8528035 C54.8115045,43.8528035 55.1895091,44.2324576 55.1895091,44.699301 L55.1895091,51.8227892 L59.3043648,51.8227892 L59.3043648,11.9745538 C53.5668708,10.4775229 49.0815959,5.83596546 47.7807039,0 L2.10704885,0 Z",
    id: "Path",
    fill: "#07A0C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83443441,33.8599004 L8.83443441,2.11624377 C8.83443441,0.947442338 9.77776018,0 10.9414833,0 L2.10704885,0 C0.943325769,0 0,0.947442338 0,2.11624377 L0,33.8599004 L8.83443441,33.8599004 Z",
    id: "Path",
    fill: "#067A99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.129199,26.4276523 L13.1751657,26.4276523 C12.0114427,26.4276523 11.0681169,25.4802099 11.0681169,24.3114085 L11.0681169,14.3904577 C11.0681169,13.2216562 12.0114427,12.2742139 13.1751657,12.2742139 L46.129199,12.2742139 C47.2929221,12.2742139 48.2362479,13.2216562 48.2362479,14.3904577 L48.2362479,24.3114085 C48.2362479,25.4802099 47.2929221,26.4276523 46.129199,26.4276523 Z",
    id: "Path",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6840396,24.3114085 L17.6840396,14.3904577 C17.6840396,13.2216562 18.6273653,12.2742139 19.7910884,12.2742139 L13.1751657,12.2742139 C12.0114427,12.2742139 11.0681169,13.2216562 11.0681169,14.3904577 L11.0681169,24.3114085 C11.0681169,25.4802099 12.0114427,26.4276523 13.1751657,26.4276523 L19.7910884,26.4276523 C18.6273653,26.4276523 17.6840396,25.4802099 17.6840396,24.3114085 Z",
    id: "Path",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5315477,67.8857143 L80.2475875,67.8857143 C82.3205022,66.0909279 83.6346685,63.4363118 83.6346685,60.4716658 C83.6346685,55.0661444 79.2716025,50.6840384 73.8895676,50.6840384 C68.5075327,50.6840384 64.1444667,55.0661444 64.1444667,60.4716658 C64.1444667,63.4363118 65.4584223,66.0909279 67.5315477,67.8857143 Z",
    id: "Path",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#8B8892",
    cx: 73.8895676,
    cy: 60.4716658,
    rx: 5.2149459,
    ry: 5.23770334
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 73.8895676,
    cy: 60.4716658,
    rx: 2.79183972,
    ry: 2.804023
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3101292,60.4716658 C73.3101292,59.3202176 74.0052446,58.3293923 74.9957682,57.8983134 C74.6563227,57.7505996 74.2825322,57.6676428 73.8895676,57.6676428 C72.3501577,57.6676428 71.0977279,58.9255381 71.0977279,60.4716658 C71.0977279,62.0177935 72.349947,63.2756888 73.8895676,63.2756888 C74.2825322,63.2756888 74.6563227,63.1927321 74.9957682,63.0450183 C74.0052446,62.6137278 73.3101292,61.6231141 73.3101292,60.4716658 Z",
    id: "Path",
    fill: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(50.5749, 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#875EA0",
    cx: 16.0359281,
    cy: 16.0457143,
    rx: 16.0359281,
    ry: 16.0457143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52230973,24.2130877 C6.32067113,22.1841963 4.94032359,19.2766709 4.94032359,16.0457143 C4.94032359,12.8147576 6.32067113,9.90723227 8.52230973,7.87834084 C10.8038135,4.02778891 14.6467766,1.21234286 19.1802278,0.310426891 C18.1633613,0.108020168 17.1123267,-6.52027452e-16 16.0359281,-6.52027452e-16 C7.17948417,-6.52027452e-16 0,7.18386555 0,16.0457143 C0,24.907563 7.17948417,32.0914286 16.0359281,32.0914286 C17.1123267,32.0914286 18.1633613,31.9834084 19.1802278,31.7810017 C14.6467766,30.8790857 10.8038135,28.0636397 8.52230973,24.2130877 Z",
    id: "Path",
    fill: "#7A6D98"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 16.0359281,
    cy: 16.0457143,
    rx: 11.0956046,
    ry: 11.1023758
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25178725,16.0457143 C9.25178725,10.6522568 13.0957984,6.15882756 18.19166,5.15455462 C17.4940447,5.01716975 16.7737905,4.94333849 16.0359281,4.94333849 C9.90810739,4.94333849 4.94032359,9.9139442 4.94032359,16.0457143 C4.94032359,22.1774844 9.90789777,27.1480901 16.0359281,27.1480901 C16.7737905,27.1480901 17.4942543,27.0742588 18.19166,26.9368739 C13.0957984,25.932601 9.25178725,21.4391718 9.25178725,16.0457143 Z",
    id: "Path",
    fill: "#F3F0FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.8017352,17.6825869 L15.9722037,17.6825869 C15.5426923,17.6825869 15.1320468,17.5068182 14.8354345,17.1961815 L9.37734961,11.4797123 C8.77762686,10.8515173 8.80026582,9.85563429 9.42807765,9.25554555 C10.0552606,8.65545681 11.0505363,8.67810958 11.6508879,9.30630454 L16.6444549,14.5363684 L21.8017352,14.5363684 C22.6701908,14.5363684 23.373885,15.2407018 23.373885,16.1094776 C23.373885,16.9782534 22.6699811,17.6825869 21.8017352,17.6825869 L21.8017352,17.6825869 Z",
    id: "Path",
    fill: "#A79BC6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#875EA0",
    cx: 16.0359281,
    cy: 16.0457143,
    rx: 2.70263035,
    ry: 2.70427966
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(33.9222, 61.9486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6143708,0 L0,0 L0,24.0685714 L24.6706587,24.0685714 L24.6706587,1.05044217 C24.6706587,0.470177917 24.197653,0 23.6143708,0 Z",
    id: "Path",
    fill: "#FCB043"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E2791B",
    points: "0.211257567 0 4.85892404 0 4.85892404 23.858483 0.211257567 23.858483"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7647914,8.25815619 L10.1171249,8.25815619 C9.53384274,8.25815619 9.06083705,7.78776818 9.06083705,7.20771402 L9.06083705,0 L15.8210792,0 L15.8210792,7.20771402 C15.8210792,7.78776818 15.3480735,8.25815619 14.7647914,8.25815619 Z",
    id: "Path",
    fill: "#F41381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7839471,7.20771402 L11.7839471,0 L9.06083705,0 L9.06083705,7.20771402 C9.06083705,7.78776818 9.53384274,8.25815619 10.1171249,8.25815619 L12.8402349,8.25815619 C12.2569528,8.25815619 11.7839471,7.78776818 11.7839471,7.20771402 Z",
    id: "Path",
    fill: "#F41381"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.6383724,60.7142857 L68.451448,60.7142857 C68.1161062,60.7142857 67.8443114,60.4552786 67.8443114,60.1357143 L67.8443114,58.2071429 C67.8443114,57.8875786 68.1161062,57.6285714 68.451448,57.6285714 L74.6383724,57.6285714 C74.9737142,57.6285714 75.245509,57.8875786 75.245509,58.2071429 L75.245509,60.1357143 C75.245509,60.4552786 74.9737142,60.7142857 74.6383724,60.7142857 Z",
    id: "Path",
    fill: "#303026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2443347,53.8685319 L88.0945909,40.9657143 L72.7784431,40.9657143 L72.7784431,55.16 L96.8323353,55.16 C96.6955117,54.7076896 96.4994405,54.2725394 96.2443347,53.8685319 Z",
    id: "Path",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#8B8892",
    points: "67.7784431 40.9657143 72.7125749 40.9657143 72.7125749 55.16 67.7784431 55.16"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0, 52.0743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9221557,1.05554213 C33.9221557,0.472671765 33.453318,0 32.8751756,0 L1.04698011,0 C0.468837695,0 0,0.472671765 0,1.05554213 L0,23.5546337 C1.56418829,27.1814765 3.52685721,30.5934109 5.83523897,33.7317487 L6.65628077,33.9428571 L33.9221557,33.9428571 L33.9221557,1.05554213 Z",
    id: "Path",
    fill: "#FCB043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.44520958,1.05554213 C6.44520958,0.472671765 6.91404728,0 7.49218969,0 L1.04698011,0 C0.468837695,0 0,0.472671765 0,1.05554213 L0,23.5546337 C1.56418829,27.1814765 3.52685721,30.5934109 5.83523897,33.7317487 L6.44520958,33.8886023 L6.44520958,1.05554213 Z",
    id: "Path",
    fill: "#E2791B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1020182,11.6109634 L13.8201375,11.6109634 C13.2419951,11.6109634 12.7731574,11.1382917 12.7731574,10.5554213 L12.7731574,0 L21.1489983,0 L21.1489983,10.5554213 C21.1489983,11.1382917 20.6801606,11.6109634 20.1020182,11.6109634 Z",
    id: "Path",
    fill: "#F41381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8680306,10.5554213 L15.8680306,0 L12.7731574,0 L12.7731574,10.5554213 C12.7731574,11.1382917 13.2419951,11.6109634 13.8201375,11.6109634 L16.9150107,11.6109634 C16.3368683,11.6109634 15.8680306,11.1382917 15.8680306,10.5554213 Z",
    id: "Path",
    fill: "#F41381"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.0932125,94.04 L12.9520958,94.2490323 C22.0844157,102.184733 34.0633901,107 47.1826347,107 C60.3018793,107 72.2810654,102.184733 81.4131737,94.2490323 L80.2720569,94.04 L14.0932125,94.04 Z",
    id: "Path",
    fill: "#303026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5508982,86.0171429 C7.73848144,88.9461491 10.2324151,91.6354101 12.9851293,94.04 L81.3801401,94.04 C84.1328543,91.6354101 86.626788,88.9461491 88.8143713,86.0171429 L5.5508982,86.0171429 Z",
    id: "Path",
    fill: "#8B8892"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8323353,60.0971429 L92.9261477,60.0971429 C92.358517,60.0971429 91.8982036,60.570897 91.8982036,61.155102 L91.8982036,66.444898 C91.8982036,67.029103 92.358517,67.5028571 92.9261477,67.5028571 L96.8323353,67.5028571 L96.8323353,60.0971429 Z",
    id: "Path",
    fill: "#FFFFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingPackages116X116);
export default __webpack_public_path__ + "static/media/shipping-packages_116x116.81705b7c96a8f8a75b12e19c80891d37.svg";
export { ForwardRef as ReactComponent };